import { render, staticRenderFns } from "./SmsShow.vue?vue&type=template&id=f0867196&scoped=true&"
import script from "./SmsShow.vue?vue&type=script&lang=js&"
export * from "./SmsShow.vue?vue&type=script&lang=js&"
import style0 from "./SmsShow.vue?vue&type=style&index=0&id=f0867196&prod&scoped=true&lang=css&"
import style1 from "./SmsShow.vue?vue&type=style&index=1&id=f0867196&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0867196",
  null
  
)

export default component.exports